export const RECEIVED_ACCESSIBILITY_SETTINGS =
  'RECEIVED_ACCESSIBILITY_SETTINGS';
export const UPDATED_ACCESSIBILITY_SETTINGS = 'UPDATED_ACCESSIBILITY_SETTINGS';
